import { findNavItemByHref, type NavLeaf } from './findNavItemByHref';
import { findTableByRoute } from '../config/dataTables.registry';
import DataManagementIcon from '../components/icons/DataManagementIcon';

/** Suffix that marks a favorited Table Maint in the Favorites submenu. */
export const TABLE_MAINT_SUFFIX = ' (Table Maint)';

/**
 * Resolve the page at `pathname` to something the Favorites star can save and the
 * Favorites submenu can render. Sidebar leaves come first; a Data Management table
 * (reached through the hub, so never a sidebar leaf) resolves from the table
 * registry with a suffixed label and the Table Maintenance icon.
 *
 * Returns null for pages that can't be favorited (PRO details, search results, …).
 */
export function resolveFavoritable(navigation: any[], pathname: string): NavLeaf | null {
  pathname = pathname.split(/[?#]/)[0];
  const leaf = findNavItemByHref(navigation, pathname);
  if (leaf) return leaf;

  if (pathname.startsWith('/data-management/')) {
    const table = findTableByRoute(pathname);
    if (table) {
      return { name: `${table.label}${TABLE_MAINT_SUFFIX}`, href: table.route, icon: DataManagementIcon };
    }
  }
  return null;
}
